module.exports = __webpack_public_path__ + "img/time.f1e058ed.svg";